import { isTestEnvironment } from './utils';
function getIsSlowPlayerAnimations() {
    if (!isTestEnvironment()) {
        return false;
    }
    const params = new URLSearchParams(window.location.search);
    return params.get('slowPlayerAnimations') === 'true';
}
const IS_SLOW_PLAYER_ANIMATIONS = getIsSlowPlayerAnimations();
/**
 * In tests, player animations can be run more slowly to decrease the chance that Cypress will "miss" a short period
 * of time when it is trying to assert on an active animation.
 */
export const MINIMUM_PLAYER_ANIMATION_DURATION_MS = IS_SLOW_PLAYER_ANIMATIONS ? 2000 : 0;
